<template>
  <div class="app-wrapper">
    <div class="label bold">
      三溪浦水库位于宁波市鄞州区东吴镇境内，与东南佛国之称的天童寺、舍利宝刹阿育王寺相毗邻。水库汇合天童、凤下、画龙三溪之水，山清水秀，风光旖旎，与有着西湖风光、太湖气魄的东钱湖遥相辉映，如神手连百里太白，映平湖诗画天成，人称“太白湖”。
    </div>
    <div class="label bold">
      三溪之水于此汇聚、中转，儒、道、释三教文化于此荟聚、传播，掠过的是历史，连接的是一个水库的过去与未来。
    </div>
    <div class="label">
      1958年9月26日，三溪浦水库建设在大跌进的擂鼓声中拉开序幕。建设者们头顶蓝天，脚踏黄土，撑一杆竹篙，挂一片云帆，喊一声号子，最是荡气回肠！经过五个春秋的日夜奋战，用汗水筑起了一座防洪屏障，这座原以灌溉为主，现为防洪、供水为主的水库，护了一方水域，泽了万世生灵！
    </div>
    <div class="img-wrapper">
      <img :src="wz1" alt="">
      <div class="img-text">1962年12月，建设输水隧洞</div>
    </div>
    <div class="img-wrapper">
      <img :src="wz2" alt="">
      <div class="img-text">1963年4月，三溪浦水库建设工程竣工</div>
    </div>
    <div class="img-wrapper">
      <img :src="wz3" alt="">
      <div class="img-text">上世纪60年代的水库办公楼</div>
    </div>
    <div class="label">
      水库自建成投入使用已近60年，历经4次维修。其中，2013年至2015年进行的维修加固，总投资7504万元，主要对大坝实施混凝土防渗墙加固改造。经维修加固后，三溪浦水库根除了大坝渗漏的安全隐患，并通过改建泄洪洞，使水库具备了预泄功能。
    </div>
    <div class="img-wrapper">
      <img :src="wz4" alt="" style="margin-bottom: 5px">
      <img :src="wz5" alt="">
      <div class="img-text">摄于2013年三溪浦水库维修加固工程期间</div>
    </div>
    <div class="label">
      三溪浦水库集雨面积48.8平方公里，总库容3382万立方米，水库按50年一遇防洪标准设计， 2000年一遇防洪标准校核。其枢纽工程由大坝（砼防渗墙心墙砂壳坝）、溢洪道、泄洪洞、输水隧洞等建筑物组成，是一座以防洪、供水为主，结合灌溉、养鱼等综合利用的中型水库，地理位置重要，2005年被认定为“全国防汛重点中型水库”。
    </div>
    <div class="label">
      水库的建成，改变了鄞东南平原的水利面貌，工程效益显著。一是防洪，水库成功抵御了多次较大洪水，通过水库合理调度运行，充分发挥了水库拦蓄滞洪作用，确保了下游人民群众的生命财产安全。二是供水，水库承担镇海炼化公司、镇海港埠公司、邱隘镇、五乡镇、东吴镇等供水任务，每年供水约3000万方，保证生活、工业用水安全。三是灌溉，水库灌溉鄞东南36.98万亩土地（与东钱湖、横溪水库统一调度），多年平均灌溉用水约50万方，促进了地方农业的迅速发展。
    </div>
    <div class="img-wrapper">
      <img :src="wz6" alt="">
      <div class="img-text">三溪浦水库全景</div>
    </div>
    <div class="label">
      多年来，水库坚持以抗旱兴利调度为重心，认真完成防汛抗旱、标准化管理、水资源保护、供水保障、安全生产等各项工作任务。在日常工作中，水库职工立足本职、科学管理，认真做好工程检查、大坝巡查和安全监测工作；做好工程设施设备的维护和保养；坚持不懈抓好安全生产，积极开展应急演练，常态化组织岗位培训，严格落实防汛物资管理制度；及时编制调度规程、控制运行计划、应急预案等有关报告和制度；切实做好水库的水质巡查、水质监测及对突发事件的处置工作，保证供水安全。
    </div>
    <div class="img-wrapper">
      <img :src="wz7" alt="">
      <div class="img-text">三溪浦水库池杉林</div>
    </div>
    <div class="label">
      水库坚持以人为本，不断提升管理水平，先后被评为市水库管理工作先进单位、市卫生先进单位、市绿化先进单位、市文明单位、档案工作目标管理市二级认定单位、区先进基层党组织、宁波十大最美湖泊等荣誉称号，并顺利通过省级水库工程管理标准化验收。水库重视思想道德建设和文化建设，积极开展各项文体活动，积极投身公益事业，为推动水库文明单位建设不断努力
    </div>
    <div class="label">
      近年来，美丽的三溪浦水库吸引了大批前来参观学习、社会实践、净化库区的学生和志愿者，他们为三溪浦水库这个“大水缸”注入了青春色彩
    </div>
    <div class="label bold">
      自洪荒深处，迤逦而来。
    </div>
    <div class="label bold">
      吮百川，吸清流，蓄积成泱泱之水。
    </div>
    <div class="label bold">
      奔泻天来，滋润鄞东万户。
    </div>
    <div class="label bold">
      波峰浪谷，响彻激扬，奏响三溪浦新乐章！
    </div>
    <div class="img-wrapper">
      <img :src="wz8" alt="">
      <div class="img-text">三溪浦水库</div>
    </div>
    <div class="label">
      站在历史新的起点，面对新机遇、新挑战，新时期的水库人将肩负继往开来的重任，传承老一辈建设者的优良传统，团结拼搏，与时俱进，在建设标准化、现代化水库的新征程中再立新功，再创辉煌！
    </div>
    <!--  底部按钮组  -->
    <div class="btn-group">
      <div class="btn-item">
        <span class="btn-text" @click="toPage">首 页</span>
      </div>
      <div class="btn-item">
        <span class="btn-text">科普问答</span>
      </div>
      <div class="btn-item">
        <span class="btn-text">关于我们</span>
      </div>
    </div>
  </div>
</template>

<script>
import wz1 from '../assets/About/wz1.webp';
import wz2 from '../assets/About/wz2.webp';
import wz3 from '../assets/About/wz3.webp';
import wz4 from '../assets/About/wz4.webp';
import wz5 from '../assets/About/wz5.webp';
import wz6 from '../assets/About/wz6.webp';
import wz7 from '../assets/About/wz7.jpg';
import wz8 from '../assets/About/wz8.webp';
export default {
  name: "ABOUT",
  data() {
    return {
      wz1,
      wz2,
      wz3,
      wz4,
      wz5,
      wz6,
      wz7,
      wz8,
    }
  },
  methods: {
    toPage() {
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>

<style scoped>
.app-wrapper {
  box-sizing: border-box;
  position: relative;
  width: 100vw;
  min-height: 100vh; /* 确保容器至少有一屏高度 */
  overflow: visible; /* 允许内容溢出 */
  background-size: cover;
  padding: 24px;
  color: #000;
}
.label {
  text-indent: 2em;
  margin-bottom: 1em;
}
.bold {
  font-weight: 600;
}
.img-wrapper {
  padding: 10px;
}
.img-text {
  font-size: 16px;
  font-size: 12px;
  color: #457fb3;
  border-left: 2px solid #457fb3;
  padding-left: 5px;
  margin-top: 5px;
}
.btn-group {
  display: flex;
  justify-content: space-between;
  position: fixed;
  padding: 0 24px;
  bottom: 10px;
  left: 0;
  width: calc(100% - 48px);
  z-index: 3;
}
.btn-item {
  width: 110px;
  height: 30px;
  line-height: 30px;
  background-color: #7db7d9;
  text-align: center;
  border-radius: 4px;
  font-weight: 800;
  font-size: 20px;
  box-shadow: 0px 15px 15px 0px rgba(0, 0, 0, 0.2);
}
.btn-text {
  background-image: linear-gradient(to right , #fff, #fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>